import api from "../axios";

export const GetVendorNotification = (data) =>
  api.patch(`notification/all`, data);
export const GetUserNotification = (data) =>
  api.patch(`user/notification/all`, data);
export const GetNotificationCount = (data) =>
  api.post("notification/count", data);
export const GetVendorUnreadNotification = (data) =>
  api.get("vendor/notification/count", data);
export const DeleteVendorNotification = (data) =>
  api.delete("notification/delete", data);
export const DeleteUserNotification = (data) =>
  api.post("user/notification/delete", data);
